import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-keys';
import { useContentApi } from './use-content-api';

type BannerResponse = Awaited<ReturnType<ReturnType<typeof useContentApi>['banner']['getBanner']>>;
type InfoBannerResponse = Awaited<ReturnType<ReturnType<typeof useContentApi>['infoBanner']['getInfoBanner']>>;

export const useGetBanner = (
  options?: Omit<UseQueryOptions<BannerResponse>, 'queryKey' | 'queryFn'>
) => {
  const contentApi = useContentApi();
  return useQuery({
    queryKey: [QUERY_KEYS.learning.banner()],
    queryFn: () => contentApi.banner.getBanner(),
    ...options,
  });
};

export const useGetInfoBanner = (
  options?: Omit<UseQueryOptions<InfoBannerResponse>, 'queryKey' | 'queryFn'>
) => {
  const contentApi = useContentApi();
  return useQuery({
    queryKey: [QUERY_KEYS.learning.infoBanner()],
    queryFn: () => contentApi.infoBanner.getInfoBanner(),
    ...options,
  });
};